import { render, staticRenderFns } from "./error500.vue?vue&type=template&id=1620e4a0&scoped=true"
import script from "./error500.vue?vue&type=script&lang=js"
export * from "./error500.vue?vue&type=script&lang=js"
import style0 from "./error500.vue?vue&type=style&index=0&id=1620e4a0&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620e4a0",
  null
  
)

export default component.exports